import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";
import { SingleGoalSelectorModalComponent } from "./single-goal-selector-modal/single-goal-selector.component";
import { SingleGoalSelection } from "./single-goal-selector.types";

@Injectable({
  providedIn: "root",
})
export class SingleGoalSelectorService {
  public constructor(private modalService: UiModalService) {}

  public openSingleGoalSelectModal(options: { unselectableId?: string; enableOkrSelectionOnly?: boolean }): Subject<SingleGoalSelection> {
    const singleGoalSelectorModal = this.modalService.create({
      uiContent: SingleGoalSelectorModalComponent,
      uiClassName: "single-goal-selector-modal",
      uiData: {
        unselectableId: options.unselectableId,
        enableOkrSelectionOnly: options.enableOkrSelectionOnly,
      },
      uiWidth: 900,
      uiStyle: { top: "30px" },
      uiFooter: null,
    });
    return singleGoalSelectorModal.afterClose;
  }
}
